module.exports = __webpack_public_path__ + "img/tech_tab.2153c14.webp";